<script>
	import ScAddAuthority from './SCAddAuthority.svelte';
	import ScExistingAuthorities from './SCExistingAuthorities.svelte';
</script>

<div class="mb-4">
	<ScAddAuthority />
	<ScExistingAuthorities />
</div>
